module.exports = __webpack_public_path__ + "img/drivelogo_transparent.1d185153.png";